import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Tab, Nav } from 'react-bootstrap';
import styleClasses from '../../try2.module.scss';
import FavoriteButton from '../FavoriteButton';
import BackButton from '../../../../components/BackButton';
import * as CONSTANT from '../../../../constants';
import { ITabContent } from '../../../../models/try2Combo';
import { useDispatch } from 'react-redux';
import { resetTry2ComboItemContext } from '../../../../redux/slices/itemCustomizationSlice';
import { verifyStatus } from '../../../../helpers/customizedItem/customizedItem.helper';
import { ICustomizedItem } from '../../../../models/item.model';
import AddToComboButton from './Buttons/AddToComboButton';
import CustomizeButton from './Buttons/CustomizeButton';
import OrderButton from './Buttons/OrderButton';
import NotAvailableButton from './Buttons/NotAvailableButton';
import TagSymbol from '../../../../components/Molecules/Symbols/Symbol';
import { useAppSelector } from '../../../../redux/store/store';
import useCheckMobileScreen from '../../../../hooks/useCheckMobileScreen';
import ItemActions from './ItemActions';
import Try2ComboItems from './Try2ComboItems';

const TabContent: React.FC<ITabContent> = (props) => {
  const {
    selectedFilters,
    categories,
    userId,
    backButtonClick,
    addToComboClickHandler,
    favIcon,
    favourite,
    favButtonHandler,
    customizeModal,
    sectionSelected,
    scrollToItems,
    setScrollToItems,
    userType,
    itemDetails
  } = props;

  const dispatch = useDispatch();
  const isItMobile = useCheckMobileScreen();
  const scrollTab = React.useRef<HTMLDivElement>(null);
  const order = useAppSelector((state: any) => state.itemCustomization);

  useEffect(() => {
    const item = order?.modifiers.find((item) => item.item === sectionSelected);
    if (item?.category_id && scrollToItems) {
      setScrollToItems(false);
      // scrollTab.current.scrollIntoView()
      let headerOffset = -150;
      if (isItMobile) {
        headerOffset = -45;
      }
      const elementPosition = scrollTab.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset + headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  }, [order]);

  return (
    <Tab.Content ref={scrollTab}>
      {categories?.map((category) => (
        <Tab.Pane key={category.id} eventKey={category.id}>
          <Container fluid className='px-0 px-md-3'>
            <hr className="mb-40" />
            <div className="mb-3">
              <BackButton
                handleClick={() => {
                  dispatch(
                    resetTry2ComboItemContext({
                      category_id: category.id,
                    })
                  );
                  backButtonClick();
                }}
              />
            </div>
            <h6 className="font-Cls text-start mb-4">{category.name}</h6>
            <Row
              className={`${styleClasses.item_details_row_wrap} pt-2 d-md-flex`}
            >
              <Try2ComboItems
                category={category}
                selectedFilters={selectedFilters}
                userId={userId}
                userType={userType}
                favButtonHandler={favButtonHandler}
                favIcon={favIcon}
                favourite={favourite}
                customizeModal={customizeModal}
                addToComboClickHandler={addToComboClickHandler}
                showItemDetails={itemDetails}
                category_name={category.name}
                />
              {/* <OrderButton /> */}
            </Row>
          </Container>
        </Tab.Pane>
      ))}
    </Tab.Content>
  );
};

export default TabContent;
